(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListDialogController', PresentListDialogController);

    PresentListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PresentList'];

    function PresentListDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PresentList) {
        var vm = this;
        vm.presentList = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:presentListUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.presentList.id !== null) {
                PresentList.update(vm.presentList, onSaveSuccess, onSaveError);
            } else {
                PresentList.save(vm.presentList, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
